import React, { useState } from "react";
import "../pages/Home.css";
import videoFile from "../assets/videoplayback.mp4";
import { useNavigate } from "react-router-dom";

const ISSUE_OPTIONS = [
  "Screen Replacement",
  "Battery Replacement",
  "Water Damage Repair",
  "Motherboard Repair",
];

const Hero = () => {
  const [selectedIssues, setSelectedIssues] = useState([]);
  const [model, setModel] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleBooking = () => {
    if (!model.trim()) {
      setError("Please enter your device model.");
      return;
    }

    if (selectedIssues.length === 0) {
      setError("Select at least one repair issue.");
      return;
    }

    setError("");

    sessionStorage.setItem(
      "homeRepairDraft",
      JSON.stringify({
        model: model.trim(),
        issues: selectedIssues,
      })
    );

    navigate("/login");
  };

  const toggleIssue = (issue) => {
    setSelectedIssues((prev) =>
      prev.includes(issue)
        ? prev.filter((i) => i !== issue)
        : [...prev, issue]
    );
  };

  return (
    <section className="hero">
      <video autoPlay muted loop playsInline className="hero-video">
        <source src={videoFile} type="video/mp4" />
      </video>

      <div className="video-overlay"></div>

      <div className="hero-content">
        {/* LEFT */}
        <div className="hero-left">

          {/* ✅ H1 SAME (NO CHANGE) */}
          <h1 className="hero-title">
            Service at your <br />
            <span className="glow">doorstep</span>, simplified
          </h1>

          <br/>

          {/* ✅ SEO IMPROVED TEXT */}
          <p className="hero-sub" style={{ color:"white", textAlign: "justify" }}>
           Fast and reliable mobile repair service at your doorstep in Bangalore.
We fix screen damage, battery issues, water damage and more with certified technicians.
          </p>

          {/* ✅ HIDDEN SEO BOOST */}
          <div style={{ display: "none" }}>
            mobile repair near me, phone repair near me, doorstep mobile repair,
            screen replacement service, battery replacement mobile repair India
          </div>

          <div className="tech-grid">
            <div className="grid-item">
              <small>FIX TIME</small>
              <p>45m</p>
            </div>

            <div className="grid-item">
              <small>PARTS</small>
              <p>100% OEM</p>
            </div>

            <div className="grid-item">
              <small>WARRANTY</small>
              <p>LIFETIME</p>
            </div>
          </div>
        </div>

        {/* RIGHT CARD */}
        <div className="quote-card">
          <h3>BOOK REPAIR</h3>

          <div className="issue-selector">
            {ISSUE_OPTIONS.map((issue) => (
              <button
                key={issue}
                className={`issue-box ${
                  selectedIssues.includes(issue) ? "active" : ""
                }`}
                onClick={() => toggleIssue(issue)}
              >
                {issue}
              </button>
            ))}
          </div>

          <p className="issue-selection-note">
            {selectedIssues.length > 0
              ? `${selectedIssues.length} issue${
                  selectedIssues.length > 1 ? "s" : ""
                } selected`
              : "Select one or more repair issues"}
          </p>

          {/* ✅ INPUT SEO */}
          <input
            type="text"
            placeholder="Enter Mobile Model (e.g. iPhone 15 Pro)"
            value={model}
            onChange={(e) => setModel(e.target.value)}
          />

          {error && <p className="error-text">{error}</p>}

          {/* ✅ BUTTON SEO */}
          <button className="action-btn" onClick={handleBooking}>
            BOOK MOBILE REPAIR
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;